
document.addEventListener("DOMContentLoaded", function() {
  let observer;
  function addReturnToCartButton() {
    const target = document.getElementById("aod_smart_cart_saver");
    if (target && !document.querySelector(".ctm-return-to-cart")) {
      const wrapper = document.createElement("div");
      wrapper.className = "ctm-return-to-cart";

      const button = document.createElement("button");
      button.type = "button";
      button.name = "return";
      button.value = "return to cart";
      button.className = "c-btn c-btn--primary";
      button.textContent = "Return to Cart";

      // Redirect on click
      button.addEventListener("click", function() {
        window.location.href = "https://www.blindsdownunder.com.au/cart";
      });

      wrapper.appendChild(button);
      target.appendChild(wrapper);

      if (observer) {
        observer.disconnect();
      }
    }
  }

  // Handle dynamic loading of app content
  observer = new MutationObserver(addReturnToCartButton);
  observer.observe(document.body, { childList: true, subtree: true });

  // Run once immediately
  addReturnToCartButton();

  const buttons = document.querySelectorAll('.aod-save-cart-button, .aod-view-cart-button');
  const loader = document.getElementById('aod_loader');

  if (buttons.length && loader) {
    buttons.forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        // Show the full-page loader
        loader.classList.remove('DisplayNone');

         //Keep loader visible for 10 second (1000ms)
        setTimeout(() => {
          loader.classList.add('DisplayNone');
        }, 10000);
      });
    });
  }
  // Header scroll logic
  const header = document.querySelector('#header');
  if (header) {
    let ticking = false;
    const updateHeaderOnScroll = () => {
      if (window.scrollY > 150) {
        header.classList.add('top-fix');
      } else {
        header.classList.remove('top-fix');
      }
      ticking = false;
    };

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateHeaderOnScroll);
      }
    }, { passive: true });
  }

  // --- Mega Menu Interaction Logic (Vanilla JS) ---
  // --- Full Navigation & Mega Menu Interaction Logic (Vanilla JS) ---
  const initNavigation = () => {
    const isMobile = () => window.innerWidth < 769;
    const isTouch = () => ( 'ontouchstart' in window ) || ( navigator.maxTouchPoints > 0 ) || ( navigator.msMaxTouchPoints > 0 );

    // 1. Hamburger Menu Toggle
    const navToggle = document.getElementById('wsnavtoggle');
    const navContainer = document.querySelector('.wsmenucontainer');
    const overlapBg = document.querySelector('.overlapblackbg');

    if (navToggle && navContainer) {
      navToggle.addEventListener('click', (e) => {
        e.preventDefault();
        navContainer.classList.toggle('wsoffcanvasopener');
      });
    }

    if (overlapBg && navContainer) {
      overlapBg.addEventListener('click', () => {
        navContainer.classList.remove('wsoffcanvasopener');
      });
    }

    // 2. Mobile Submenu Expansion (Plus/Minus Arrows)
    const setupSubmenuToggles = () => {
      const menuLists = document.querySelectorAll('.wsmenu-list');
      menuLists.forEach(list => {
        const itemsWithExtras = list.querySelectorAll('li');
        itemsWithExtras.forEach(li => {
          const hasSub = li.querySelector('.wsmenu-submenu, .megamenu, .wsmenu-submenu-sub, .wsmenu-submenu-sub-sub');
          if (hasSub && !li.querySelector('.wsmenu-click, .wsmenu-click02')) {
            const span = document.createElement('span');
            span.className = li.parentElement.classList.contains('wsmenu-list') ? 'wsmenu-click' : 'wsmenu-click02';
            span.innerHTML = '<i class="wsmenu-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.73379 9.9026 7.61934 9.95001 7.49999 9.95001C7.38064 9.95001 7.26618 9.9026 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z"/></svg></i>';
            li.prepend(span);
          }
        });
      });

      // Handle click on the arrows (Mobile Drawer)
      document.body.addEventListener('click', (e) => {
        const toggle = e.target.closest('.wsmenu-click, .wsmenu-click02');
        if (toggle && isMobile()) {
          e.preventDefault();
          e.stopPropagation();

          const parentLi = toggle.parentElement;
          const submenu = parentLi.querySelector('.wsmenu-submenu, .megamenu, .wsmenu-submenu-sub, .wsmenu-submenu-sub-sub');
          const siblingDots = parentLi.parentElement.querySelectorAll(':scope > li > .wsmenu-click, :scope > li > .wsmenu-click02');

          // Toggle current
          const isActive = toggle.classList.toggle('ws-activearrow');
          const arrowIcon = toggle.querySelector('.wsmenu-arrow');
          if (arrowIcon) arrowIcon.classList.toggle('wsmenu-rotate', isActive);

          if (submenu) {
             if (isActive) {
               submenu.style.display = 'block';
             } else {
               submenu.style.display = 'none';
             }
          }

          // Close siblings
          siblingDots.forEach(sibToggle => {
            if (sibToggle !== toggle) {
              sibToggle.classList.remove('ws-activearrow');
              const sibArrow = sibToggle.querySelector('.wsmenu-arrow');
              if (sibArrow) sibArrow.classList.remove('wsmenu-rotate');
              const sibLi = sibToggle.parentElement;
              const sibSub = sibLi.querySelector('.wsmenu-submenu, .megamenu, .wsmenu-submenu-sub, .wsmenu-submenu-sub-sub');
              if (sibSub) sibSub.style.display = 'none';
            }
          });
        }
      });
    };

    setupSubmenuToggles();

    // Global touch detection to distinguish between real mouse hover and simulated touch hovers
    let lastTouchTime = 0;
    document.addEventListener('touchstart', () => {
      lastTouchTime = Date.now();
    }, {passive: true});

    // 3. Mega Menu Hover (Desktop) & Touch (Mobile/Tablet)
    const setupMegaMenuListeners = (selector) => {
      const items = document.querySelectorAll(selector);
      items.forEach(item => {
        let closeTimer = null;

        const openMenu = () => {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          item.classList.add('hover');
          const link = item.querySelector('a');
          if (link) link.setAttribute('aria-expanded', 'true');
        };

        const closeMenu = () => {
          item.classList.remove('hover');
          const link = item.querySelector('a');
          if (link) link.setAttribute('aria-expanded', 'false');
        };

        // Hover for Desktop (Mouse)
        item.addEventListener('mouseenter', () => {
          // If the mouseenter was triggered by a touch (simulated), ignore it
          if (Date.now() - lastTouchTime < 500) return;
          openMenu();
        });

        item.addEventListener('mouseleave', () => {
          if (Date.now() - lastTouchTime < 500) return;
          // Delay closing so cursor can travel from nav item to submenu without menu disappearing.
          // After delay, only close if cursor is truly outside the item (and all its children).
          closeTimer = setTimeout(() => {
            if (!item.matches(':hover')) closeMenu();
          }, 150);
        });

        // Touch Interaction (Tap-once-to-open, tap-again-to-close)
        item.addEventListener('touchend', (e) => {
          const hasSubmenu = item.querySelector('.wsmenu-submenu, .wsmenu-submenu-sub, .wsmenu-submenu-sub-sub, .megamenu');

          if (hasSubmenu) {
            // Ignore touches on items inside the open submenu — let them navigate
            if (e.target.closest('.wsmenu-submenu, .wsmenu-submenu-sub, .wsmenu-submenu-sub-sub, .megamenu')) return;

            if (!e.target.closest('.wsmenu-click, .wsmenu-click02')) {
              e.preventDefault();
              e.stopPropagation();

              if (item.classList.contains('hover')) {
                // Already open — close it
                item.classList.remove('hover');
                const link = item.querySelector('a');
                if (link) link.setAttribute('aria-expanded', 'false');
              } else {
                // Close all other open menu items at the same level
                const siblings = item.parentElement.querySelectorAll(':scope > li.hover');
                siblings.forEach(sib => {
                  sib.classList.remove('hover');
                  const sibLink = sib.querySelector('a');
                  if (sibLink) sibLink.setAttribute('aria-expanded', 'false');
                });

                item.classList.add('hover');
                const link = item.querySelector('a');
                if (link) link.setAttribute('aria-expanded', 'true');
              }
            }
          }
        });
      });
    };

    // Comprehensive Mega Menu Selectors covering all levels
    const megaSelectors = [
      '.wsmenu-list > li.has-submenu',
      '.wsmenu-list > li.mega_menu_simple_container',
      '.wsmenu-list > li.mega_menu_container',
      '.wsmenu-submenu > li.has-submenu-sub',
      '.wsmenu-submenu-sub > li.has-submenu-sub-sub',
      '.megamenu > ul > li',
      '.megamenu > ul > li > ul > li',
      '.multi-drop .wsmenu-list > li'
    ];
    megaSelectors.forEach(selector => setupMegaMenuListeners(selector));

    // Close menu when clicking/touching outside
    document.addEventListener('click', (e) => {
      if (!navContainer || !navContainer.contains(e.target)) {
        document.querySelectorAll('.hover').forEach(el => el.classList.remove('hover'));
      }
    });

    document.addEventListener('touchstart', (e) => {
      if (!navContainer || !navContainer.contains(e.target)) {
        document.querySelectorAll('.hover').forEach(el => {
          el.classList.remove('hover');
          const link = el.querySelector('a');
          if (link) link.setAttribute('aria-expanded', 'false');
        });
      }
    }, { passive: true });

    // Handle Resize - Reset states when switching between desktop/mobile layouts
    window.addEventListener('resize', () => {
      if (!isMobile()) {
        if (navContainer) navContainer.classList.remove('wsoffcanvasopener');
        document.querySelectorAll('.wsmenu-submenu, .megamenu, .wsmenu-submenu-sub, .wsmenu-submenu-sub-sub').forEach(el => {
          el.style.display = '';
        });
      }
    });
  };

  // --- Phase 2: Auxiliary Navigation Features (Vanilla JS) ---
  const initAuxNavigationFeatures = () => {
    // 1. Edge Detection for Dropdowns
    const checkEdgeDetection = () => {
      const docW = window.innerWidth;

      // multi-drop edge detection
      const multiDropEls = document.querySelectorAll('.multi-drop li, .multi-drop li.mega_menu_simple_container');
      multiDropEls.forEach(li => {
        const firstUl = li.querySelector('ul');
        if (firstUl) {
          const rect = firstUl.getBoundingClientRect();
          // original logic: l + w <= docW
          const isEntirelyVisible = (rect.left + rect.width <= docW);

          if (!isEntirelyVisible && docW > 767) {
            li.classList.add('edge');
          } else {
            li.classList.remove('edge');
          }
        }
      });

      // mega_menu edge/over_left_menu detection
      const megaMenuEls = document.querySelectorAll('.mega_menu > li.mega_menu_container');
      megaMenuEls.forEach(li => {
        const firstUl = li.querySelector('ul');
        if (firstUl) {
          const rect = firstUl.getBoundingClientRect();
          const isEntirelyVisible = (rect.left + rect.width <= docW);

          // Get direct children of li
          const children = Array.from(li.children);

          if (!isEntirelyVisible && docW > 767) {
            children.forEach(child => child.classList.add('over_left_menu'));
          } else {
            children.forEach(child => child.classList.remove('over_left_menu'));
          }
        }
      });
    };

    // Run on load and resize
    checkEdgeDetection();
    window.addEventListener('resize', checkEdgeDetection);

    // 2. Sticky Menu Logic
    const stickyContainer = document.querySelector('.enabled-sticky-menu');
    if (stickyContainer) {
      const contentEl = document.getElementById('content');
      const headerBot = document.querySelector('.header_bot');
      const navContainer = document.querySelector('.wsmenucontainer');
      const navToggle = document.getElementById('wsnavtoggle');
      const overlapBg = document.querySelector('.overlapblackbg');

      if (headerBot) {
        const headerPosition = headerBot.getBoundingClientRect().top + window.scrollY;

        const handleScroll = () => {
          if (window.scrollY >= headerPosition) {
            headerBot.classList.add('sticky');
          } else {
            headerBot.classList.remove('sticky');
          }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('touchmove', handleScroll, { passive: true });
      }
    }
  };

  // "Icon buttons" blocks with no Link URL are scroll-to-top controls. They used to be anchors with
  // an empty href, which returned to the top by reloading the page.
  const initScrollTopControls = () => {
    document.body.addEventListener('click', (e) => {
      if (!e.target.closest('.js-scroll-top')) {
        return;
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      window.scrollTo({ top: 0, behavior: prefersReducedMotion.matches ? 'auto' : 'smooth' });
    });
  };

  const CONSENT_BANNER_ID = 'shopify-pc__banner';
  const CONSENT_TITLE_ID = 'shopify-pc__banner__body-title';
  let watchedConsentBanner = null;

  const untagConsentBannerHeading = () => {
    const title = document.getElementById(CONSENT_TITLE_ID);

    if (!title || title.tagName !== 'H2') {
      return;
    }

    const label = document.createElement('strong');

    label.id = title.id;
    label.className = title.className;
    label.append(...title.childNodes);
    title.replaceWith(label);
  };

  // Shopify re-renders the banner on locale or region changes and through the preference flows, and a
  // re-render can replace the title alone without touching body's children — so the dialog is watched
  // through its own subtree, and body is watched for the (re-)injection of the dialog itself. Both
  // callbacks are no-ops once the retag has been applied.
  const watchConsentBanner = () => {
    const banner = document.getElementById(CONSENT_BANNER_ID);

    if (!banner) {
      return;
    }

    untagConsentBannerHeading();

    if (banner !== watchedConsentBanner) {
      watchedConsentBanner = banner;
      new MutationObserver(untagConsentBannerHeading).observe(banner, { childList: true, subtree: true });
    }
  };

  const initConsentBannerHeadingFix = () => {
    watchConsentBanner();

    new MutationObserver(watchConsentBanner).observe(document.body, { childList: true });
  };

  initNavigation();
  initAuxNavigationFeatures();
  initScrollTopControls();
  initConsentBannerHeadingFix();
});